import { Component, OnInit, Input } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { SurveyService } from '../../service/survey.service';
import { SendCommApiRequest, TypeTemplatesByMode } from '../../types/send-mails';
import { UtilityService } from 'src/app/service/utility.service';

type TypeSelectedCommunicationMode = {
 type: string, 
 value: number | null, 
 quotaType: number | string,
 quotaCount: number | string,
 templates: {id: number, template: string}[],
 disabled: boolean 
}

@Component({
  selector: 'app-send-comm',
  templateUrl: './send-comm.component.html',
  styleUrls: ['./send-comm.component.scss']
})
export class SendCommComponent implements OnInit {
  @Input() data: any;
  rewardAmount: string = "";
  selectedCommunicationModes: TypeSelectedCommunicationMode[] = [];
  communicationModes: string[] = [];
  availableModes: string[] = [...this.communicationModes];
  templatesByMode: TypeTemplatesByMode = {};
  loading: boolean = true;
  schedulingComm: boolean = false;

  constructor(private notifier: NotifierService, private surveyService: SurveyService, public utility:UtilityService) { 
    this.initSendCommOptions();
  }

  ngOnInit(): void {
    
  }

  initSendCommOptions() {
    if(!this.surveyService.sendCommData) {
      this.surveyService.getSendSurveyComm().subscribe(({data, error}) => {
        if(data && data.status === 1) {
          this.surveyService.sendCommData = { comms: data.comms, commTemplatesMap: data.commsTemplatesMap };
          this.communicationModes = data.comms;
          this.templatesByMode = data.commsTemplatesMap;
          this.loading = false;
          this.resetForm();
        } else {
          this.notifier.notify('error', "Could Not Get Send Survey Comm Details");
          this.close();
        };
      });
    } else {
      this.communicationModes = this.surveyService.sendCommData.comms;
      this.templatesByMode = this.surveyService.sendCommData.commTemplatesMap;
      this.loading = false;
      this.resetForm();
    }
  }

  resetForm() {
    this.rewardAmount = "";
    this.selectedCommunicationModes = [];
    this.availableModes = [...this.communicationModes];
    let mode = this.availableModes[0];
    let templates = this.templatesByMode[mode] || [];
    this.selectedCommunicationModes.push({
      type: this.availableModes[0],
      value: templates.length > 0 ? templates[0].id : null,
      disabled: false,
      templates: templates,
      quotaCount: "",
      quotaType: "exclusive"
    });
  }

  addCommunicationMode(i: number) {
    if (this.availableModes.length > 0) {
      this.setAvailableModes();
      this.addModeRow();
      this.selectedCommunicationModes = this.selectedCommunicationModes.map((m, idx) => ({...m, disabled: idx < (this.selectedCommunicationModes.length - 1)}));
    }
  }

  removeCommunicationMode(index: number) {
    let lastIndex = this.selectedCommunicationModes.length - 1;
    let hasLastRemoved = false;
    this.selectedCommunicationModes = this.selectedCommunicationModes.filter((m, idx) => {
      if (idx === index) {
        return false;
      } else if((index<lastIndex && lastIndex === idx)) {
        hasLastRemoved = true;
        return false;
      }
      return true;
    });
    this.setAvailableModes();
    if(hasLastRemoved)  {
      this.addModeRow();
    } else if(index === lastIndex) {
      this.selectedCommunicationModes[this.selectedCommunicationModes.length - 1].disabled = false;
      let modes = this.communicationModes.filter(m => {
        if(this.availableModes.includes(m) || this.selectedCommunicationModes[this.selectedCommunicationModes.length - 1].type === m) return true;
        return false;
      });
      this.availableModes = [...modes];
    }
    // this.selectedCommunicationModes = this.selectedCommunicationModes.map((m, idx) => ({...m, disabled: idx < (this.selectedCommunicationModes.length - 1)}));
  }

  addModeRow() { 
    let mode = this.availableModes[0];
    let templates = this.templatesByMode[mode] || [];
    let lastElement = this.selectedCommunicationModes[this.selectedCommunicationModes.length - 1];
    this.selectedCommunicationModes.push({
      type: this.availableModes[0],
      value: templates.length > 0 ? templates[0].id : null,
      disabled: false,
      templates: templates,
      quotaCount: lastElement && lastElement.quotaCount ? lastElement.quotaCount : "",
      quotaType: lastElement && lastElement.quotaType ? lastElement.quotaType : "exclusive"
    });
  }

  setAvailableModes() {
    let currModes = this.communicationModes.filter(m => !this.selectedCommunicationModes.find(sm => sm.type === m));
    this.availableModes = [...currModes];
  }

  onModeChange(index: number) {
    const selectedMode = this.selectedCommunicationModes[index].type;
    let templates = this.templatesByMode[selectedMode] || [];
    this.selectedCommunicationModes[index].templates = this.templatesByMode[selectedMode] || [];
    this.selectedCommunicationModes[index].value = templates.length > 0 ? templates[0].id : null;
  }

  sendComm() {
    if(!this.validateSendComm()) return;

    this.schedulingComm = true;

    const payload: SendCommApiRequest = {
      survey_id: this.data.uuid,
      rewardAmount: +this.rewardAmount,
      communicationModes: this.selectedCommunicationModes.map(mode => ({
        type: mode.type,
        template: mode.value,
        quotaCount: mode.quotaCount,
        quotaType: mode.quotaType
      }))
    };

    // console.log('Payload:', payload);

    this.surveyService.sendSurveyComm(payload)
    .subscribe(({ data, error }) => {
      if(data) {
        if(data.status == 1) {
          this.notifier.notify('success', data.message);
          this.close();
        } else if(data.status == 2) {
          this.notifier.notify('info', data.message);
          this.close();
        } else this.notifier.notify('error', data.message);

      } else this.notifier.notify('error', "Could Not Send Comm, Please Try again");
      this.schedulingComm = false;
    });
  }

  validateSendComm(): boolean {
    if (!this.rewardAmount || this.selectedCommunicationModes.length === 0) {
      this.notifier.notify('error', 'Please fill in all required fields.');
      return false;
    }

    if(isNaN(+this.rewardAmount)) {
      this.notifier.notify('error', 'Please enter valid numbers for reward amount.');
      return false;
    }

    let invalidSelectedComm = this.selectedCommunicationModes.find(mode => {
      if(!mode.quotaCount) return true;
      return false;
    });

    if(invalidSelectedComm) {
      this.notifier.notify('error', 'Communication count should be filled.');
      return false;
    }

    return true;
  }

  close() {
    if (this.data.ref) {
        this.data.ref.close();
    }
    if (this.data.onClose) {
        this.data.onClose();
    }
  }
}